var map = {
	"./black/arrow-left.png": 701,
	"./black/arrow-right.png": 334,
	"./white/arrow-left.png": 627,
	"./white/arrow-right.png": 396,
	"./white/exit-fullscreen.png": 76,
	"./white/fullscreen.png": 903,
	"./white/sound-off.png": 511,
	"./white/sound-on.png": 189
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 305;